import { render, staticRenderFns } from "./newRecordDialog.vue?vue&type=template&id=71c814f2"
import script from "./newRecordDialog.vue?vue&type=script&lang=js"
export * from "./newRecordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports